/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_TitleInputs */

const en_us2_intake_title = /** @type {(inputs: Intake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up your plan`)
};

const pt_br2_intake_title = /** @type {(inputs: Intake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montar seu programa`)
};

const es_419_intake_title = /** @type {(inputs: Intake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arma tu plan`)
};

const pt_pt2_intake_title = /** @type {(inputs: Intake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montar o teu plano`)
};

const fr_fr2_intake_title = /** @type {(inputs: Intake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer ton programme`)
};

const de_de2_intake_title = /** @type {(inputs: Intake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deinen Plan einrichten`)
};

const it_it2_intake_title = /** @type {(inputs: Intake_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta la tua scheda`)
};

/**
* | output |
* | --- |
* | "Set up your plan" |
*
* @param {Intake_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_title = /** @type {((inputs?: Intake_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_title(inputs)
	if (locale === "es-419") return es_419_intake_title(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_title(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_title(inputs)
	if (locale === "de-DE") return de_de2_intake_title(inputs)
	if (locale === "it-IT") return it_it2_intake_title(inputs)
	return en_us2_intake_title(inputs)
});
export { intake_title as "intake.title" }